import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getSectionDataFromdb } from "../../services/apiService";

export const fetchSectionData = createAsyncThunk(
  "jsondata/fetchSectionData",
  async (_, { rejectWithValue }) => {
    try {
      let response = await getSectionDataFromdb();
      if (response?.status_code === 200) {
        let parsedData = JSON.parse(response?.data?.[0]?.cassette);
        if (typeof parsedData === "string") {
          parsedData = JSON.parse(parsedData);
        }
        return parsedData?.map((section) => ({
          section_name: section.section_name,
          data: [
            {
              group: 1,
              initialValues: [],
              is_multi_select: null,
              key_name: "Designer Mode",
              key_value: false,
              type: "toggle_input",
            },
            ...section.data,
          ],
          is_primary: section?.is_primary,
          section_id: section?.section_id,
          previewSection: section.preview_section,
        }));
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue("Failed to fetch section data");
    }
  }
);

const initialState = {
  sectionCreateData: [],
  loading: false,
  error: null,
};

const jsonDataReducer = createSlice({
  name: "jsondata",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectionData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSectionData.fulfilled, (state, action) => {
        state.loading = false;
        state.sectionCreateData = action.payload;
      })
      .addCase(fetchSectionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message || "Unknown error";
      });
  },
});

export default jsonDataReducer.reducer;
